/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Article } from './Article'
import { ArticleFromJSON, ArticleFromJSONTyped, ArticleToJSON } from './Article'

/**
 *
 * @export
 * @interface HomePageDataBlockJournal
 */
export interface HomePageDataBlockJournal {
  /**
   *
   * @type {Array<Article>}
   * @memberof HomePageDataBlockJournal
   */
  articles: Array<Article>
}

/**
 * Check if a given object implements the HomePageDataBlockJournal interface.
 */
export function instanceOfHomePageDataBlockJournal(
  value: object
): value is HomePageDataBlockJournal {
  if (!('articles' in value) || value['articles'] === undefined) return false
  return true
}

export function HomePageDataBlockJournalFromJSON(
  json: any
): HomePageDataBlockJournal {
  return HomePageDataBlockJournalFromJSONTyped(json, false)
}

export function HomePageDataBlockJournalFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): HomePageDataBlockJournal {
  if (json == null) {
    return json
  }
  return {
    articles: (json['articles'] as Array<any>).map(ArticleFromJSON),
  }
}

export function HomePageDataBlockJournalToJSON(
  value?: HomePageDataBlockJournal | null
): any {
  if (value == null) {
    return value
  }
  return {
    articles: (value['articles'] as Array<any>).map(ArticleToJSON),
  }
}
